export default "__VITE_ASSET__BKfOpqI4__"